import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Box from '@material-ui/core/Box';
import { Home } from '@material-ui/icons';
import { LOCAL_STORAGE_SESSION_ID } from '../../actions/auth-actions';

const useStyles = makeStyles(theme => ({
  navbarItem: {
    padding: theme.spacing(0.5, 1, 0.5, 0),
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    cursor: 'pointer',
    fontSize: 16,
  },
  navbarText: {
    paddingLeft: theme.spacing(2),
    margin: 0,
  },
}));

const V1Application = () => {
  const classes = useStyles();
  const SESSION_ID = localStorage.getItem(LOCAL_STORAGE_SESSION_ID);
  const DINKASSA_V1 = `https://www.dinkassa.se/v1/default.aspx?seid=${SESSION_ID}`;
  
  const openV1 = () => {
    window.open(DINKASSA_V1, '_blank');
  };
  
  return (
    <Box className={classes.navbarItem} onClick={openV1}>
      <Home />
      <p className={classes.navbarText}>
        Dinkassa - v1
      </p>
    </Box>
  );
};

export default V1Application;